<template>
  <div>
    <!-- <section class="mountain-bg">
      <img alt="" :src="`${assetsUrl()}/images/mountain-bg.jpg`"/>
    </section> -->

    <section class="prize-section">
      <div class="container">
        <div class="row">
          <section class="col-md-12">
            <h3 class="default-heading">Winners</h3>
          </section>
        </div>
        <div class="row">
          <section class="col-md-12 winner-tab mt-0">
            <ul id="myTab" class="nav nav-tabs" role="tablist">
              <li
                  v-for="(heading, h) of makeWinners"
                  :key="h"
                  class="nav-item"
                  role="presentation"
              >
                <a
                    id="home-tab"
                    :aria-controls="convertToSlug(heading.heading)+h"
                    :class="h === 0 ? ' active show' : ''"
                    :href="'#' + convertToSlug(heading.heading)+h"
                    aria-selected="true"
                    class="nav-link"
                    data-toggle="tab"
                    role="tab"
                >{{ heading.heading }}</a
                >
              </li>
            </ul>

            <div id="myTabContent" class="tab-content">
              <div
                  v-for="(winners, w) of makeWinners"
                  :id="convertToSlug(winners.heading)+w"
                  :key="w"
                  :aria-labelledby="convertToSlug(winners.heading)+w"
                  :class="w === 0 ? ' active show' : ''"
                  class="tab-pane fade"
                  role="tabpanel"
              >
              
                <div class="row">
                  <section class="col-md-12">
                    <ul class="list-inline">
                      <li
                          class="list-inline-item test"
                          v-for="(t3winner, t3) in topThreeWinners(
                          winners.winners
                        )"
                          :key="t3"
                      >
                        <template v-if="t3winner">
                          <img
                              alt="winner trophy"
                              :src="`${assetsUrl()}/images/trophy.png`"
                          />
                          <span>{{ t3 }}</span>
                          <p>{{ t3winner }}</p>
                        </template>
                      </li>
                    </ul>
                  </section>
                </div>
                <div class="row">
                  <section class="col-md-12">
                    <ul class="list-inline stretch-list">
                      <li
                          class="list-inline-item"
                          v-for="(rWinner, rw) in remainingWinners(
                          winners.winners
                        )"
                          :key="rw"
                      >
                        <img
                            alt="winner medal"
                            :src="`${assetsUrl()}/images/medal.png`"
                        />
                        <p>{{ rWinner }}</p>
                      </li>
                    </ul>
                  </section>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {commonMixin} from "@/mixins/commonMixin";

export default {
  name: "PriceSection",
  props: ["winners"],
  mixins: [commonMixin],

  computed: {
    makeWinners() {
      return this.winners.map((winner) => {
        const heading = winner.heading;
        delete winner.heading;
        return {
          heading,
          winners: winner,
        };
      });
    },
  },

  methods: {
    convertToSlug(text) {
      if (!text) return;
      return text
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "");
    },

    topThreeWinners(winners) {
      return JSON.parse(JSON.stringify({
        1: winners.winner_1,
        2: winners.winner_2,
        3: winners.winner_3,
      }))
    },

    remainingWinners(winners) {
      delete winners.winner_1;
      delete winners.winner_2;
      delete winners.winner_3;

      return winners;
    },
  },
};
</script>

<style scoped>
.default-heading {
  font-size: 34px !important;
}

.nav-tabs .nav-item {
  width: 100%;
}

.prize-section .nav-tabs .nav-link {
  border-bottom: 1px solid wheat;
}

.prize-section .list-inline-item:not(:last-child) {
    margin-right: 60px;
}

.prize-section .stretch-list .list-inline-item:not(:last-child){
  padding: 0 20px;
}
</style>
